// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {buildDealerRecommendationExcelPayload} from '../../dealer-recommendations/services/dealer-recommendation-helper';
import {getDealerRecommendation} from '../../shared/repositories/index';
import {getFileName} from '../../../shared/services/get-file-name';
import {openFile} from '../../../shared/services/open-file';

export const exportToExcel = (accounts, language) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());
        const dealerRecommendationExcelPayload = buildDealerRecommendationExcelPayload(accounts, 'EXCEL', language);

        try {

            const response = await getDealerRecommendation(dealerRecommendationExcelPayload);

            const fileName = getFileName(response);

            const blob = await response.blob();

            openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/action-creators/export-to-excel.js